import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f5e163"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "dashboard",
  class: "d-flex flex-column page-with-no-overflow"
}
const _hoisted_2 = { class: "row padding-10 height-100" }
const _hoisted_3 = { class: "col-9 height-100 dash-overflow-hidden" }
const _hoisted_4 = { class: "col height-100" }
const _hoisted_5 = { class: "row dash-h-25p" }
const _hoisted_6 = { class: "col-12 col-md-6 col-lg-4 dash-p-0 dash-pr-5" }
const _hoisted_7 = { class: "padding-5 card height-100" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Flows")
], -1))
const _hoisted_9 = { class: "card-body dash-p-20" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, " ", -1))
const _hoisted_11 = { class: "card-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text text-success" }, " ", -1))
const _hoisted_13 = { class: "col-12 col-md-6 mb-4 mb-lg-0 col-lg-4 padding-5" }
const _hoisted_14 = { class: "padding-5 card height-100" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Running Flows")
], -1))
const _hoisted_16 = { class: "card-body dash-p-20" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, " ", -1))
const _hoisted_18 = { class: "card-text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text text-success" }, " ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Running Log")
], -1))
const _hoisted_21 = { class: "card-body dash-p-20" }
const _hoisted_22 = { class: "card-title" }
const _hoisted_23 = { class: "card-text" }
const _hoisted_24 = { class: "card-text text-success" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-6 mb-4 mb-lg-0 col-lg-4 padding-5\" data-v-40f5e163><div class=\"padding-5 card height-100\" data-v-40f5e163><div class=\"d-flex justify-content-between header\" data-v-40f5e163><div class=\"label\" data-v-40f5e163>Steps Executed</div></div><div class=\"card-body dash-p-20\" data-v-40f5e163><h5 class=\"card-title\" data-v-40f5e163>65</h5><p class=\"card-text\" data-v-40f5e163>February 1 - March 1</p><p class=\"card-text text-danger\" data-v-40f5e163> 2.6% decrease since last month </p></div></div></div>", 1)
const _hoisted_26 = { class: "row dash-h-75p dash-pt-10" }
const _hoisted_27 = { class: "col-12 col-md-6 mb-4 mb-lg-0 col-lg-12 dash-p-0 dash-pr-5 height-100" }
const _hoisted_28 = { class: "padding-5 card height-100" }
const _hoisted_29 = { class: "card-body height-100" }
const _hoisted_30 = { class: "row height-100" }
const _hoisted_31 = { class: "card-footer d-flex flex-row justify-content-between dash-bg-white border-0" }
const _hoisted_32 = { class: "col-3 padding-0 pd-l-5 height-100" }
const _hoisted_33 = { class: "card no-border scheduled-flows" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Scheduled Flows")
], -1))
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 1,
  id: "scheduled-info"
}
const _hoisted_38 = {
  key: 0,
  class: "loader-div-sm"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "card no-border recent-flows" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Latest Activities")
], -1))
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 0,
  class: "loader-div-sm"
}
const _hoisted_45 = ["src"]

import { ref, onMounted, watch, onBeforeUnmount } from "vue";
import {
  ElTimeline,
  ElTimelineItem,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElRadio,
} from "element-plus";
import i18n from "@/core/i18n/i18n";
import { LineChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import {
  getRecentLogsOrganizationSpecificList,
  getRunningFlowLogsCount,
  getFlowLogAggregation,
} from "@/dashboard/services/flow_log.service";
import ProcessLogDialog from "@/dashboard/components/ProcessLogDialog.vue";
import { authInfo, hasPermission } from "@/core/auth";
import {
  getActiveFlowCount,
  getRunningFlowsCount,
  convertDate,
  getScheduledActivities,
  isSkipped,
} from "@/flow/services/flow.service";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

Chart.register(...registerables);

const { t } = i18n.global;
const router = useRouter();
const runningFlowLogs = ref([]);
const recentActivities = ref([]);
const loadingRecentActivities = ref(false);
const loadingScheduledActivities = ref(false);
const processLogDialogVisible = ref(false);
const noRunningLogs = ref(true);
const logBuffer = ref([]);

const timeLineItems = ref([]);
const scheduledFlowItems = ref([]);

const chartData = ref({});
const setChart = ref(false);
const chartOptions = ref({});

const startDate = ref("now-1M");
const interval = ref(0);
const isStep = ref(false);

const runningFlowsCount = ref();
const activeFlowsCount = ref(0);

onMounted(() => {
  getScheduledFlows();
  getRecentActivities();
  resolveChartData();
});

onMounted(async () => {
  runningFlowsCount.value = await getRunningFlowLogsCount();
  [runningFlowLogs.value, activeFlowsCount.value] = await Promise.all([
    getRunningFlowsCount(),
    getActiveFlowCount(),
  ]);
});

async function resolveChartData() {
  const params = {
    organizationId: authInfo.value.organizationId,
    startDate: startDate.value,
    interval: interval.value,
    isStep: isStep.value,
  };
  const result = await getFlowLogAggregation(params);
  if (result) {
    chartData.value = {
      labels: [],
      datasets: [
        {
          label: "Flow Count",
          data: [],
          borderColor: "#5022a6",
          backgroundColor: "rgba(164,122,248,0.82)",
          fill: "origin",
        },
        {
          label: "Step Count",
          data: [],
          borderColor: "#e5a1ac",
          backgroundColor: "#efd2d9",
          fill: "origin",
        },
      ],
    };
    Object.entries(result)
      .sort((a, b) => new Date(a[0]).getTime() - new Date(b[0]).getTime())
      .forEach((value) => {
        chartData.value.labels.push(
          new Date(value[0]).toDateString().slice(4, 15)
        );
        chartData.value.datasets[0].data.push(value[1][0]);
        chartData.value.datasets[1].data.push(value[1][1]);
      });
  }
  /*
  {
      "2022-07-18T00:00:00.000Z": [0, 0],
      "2022-08-08T00:00:00.000Z": [4, 20],
      "2022-05-30T00:00:00.000Z": [14, 69],
      "2022-06-20T00:00:00.000Z": [51, 193],
      "2022-05-23T00:00:00.000Z": [36, 127],
      "2022-06-13T00:00:00.000Z": [70, 260],
      "2022-06-27T00:00:00.000Z": [16, 53],
      "2022-06-06T00:00:00.000Z": [54, 194],
      "2022-07-04T00:00:00.000Z": [3, 11],
      "2022-07-25T00:00:00.000Z": [2, 8],
      "2022-07-11T00:00:00.000Z": [6, 28],
      "2022-08-01T00:00:00.000Z": [0, 0],
    }
   */
  chartOptions.value = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        display: true,
      },
    },
  };
  setChart.value = true;
}

onBeforeUnmount(() => {
  clearInterval(runningFlowLogs.value);
});

async function getScheduledFlows() {
  loadingScheduledActivities.value = true;
  try {
    const response = await getScheduledActivities();
    scheduledFlowItems.value = [];
    if (Array.isArray(response)) {
      const icon = "el-icon-timer";
      scheduledFlowItems.value = response
        .sort((a, b) => Date.parse(a.nextFireTime) - Date.parse(b.nextFireTime))
        .map((item) => ({
          flowId: item.flowId,
          version: item.version,
          name: item.name,
          time: convertDate(item.nextFireTime),
          icon,
          type: "primary",
          size: "large",
        }));
    }
  } finally {
    loadingScheduledActivities.value = false;
  }
}

async function getRecentActivities() {
  loadingRecentActivities.value = true;
  const response = await getRecentLogsOrganizationSpecificList();
  if (response) {
    recentActivities.value = response.content;
    timeLineItems.value = [];
    recentActivities.value.forEach((value) => {
      let time: string =
        value.finishedOn == null ? value.startedOn : value.finishedOn;
      time = convertDate(time);
      const icon = "el-icon-video-play";
      let type: string;
      switch (value.status) {
        case "FAILED":
        case "ABORTED":
        case "STOPPED":
          type = "danger";
          break;
        case "COMPLETED":
          type = "success";
          break;
        case "WARNING":
          type = "warning";
          break;
        default:
          type = "primary";
          break;
      }

      timeLineItems.value.push({
        id: value.id,
        flowId: value.flowId,
        version: value.version,
        name: value.flowName,
        status: value.status,
        time,
        icon,
        type,
        size: "large",
      });
    });
  }
  loadingRecentActivities.value = false;
}

function closeProcessLogDialog() {
  processLogDialogVisible.value = false;
}

watch(
  () => [startDate.value, interval.value, isStep.value],
  () => {
    resolveChartData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", _hoisted_11, _toDisplayString(activeFlowsCount.value
                        ? activeFlowsCount.value + " Active Flows"
                        : "No active flow"), 1),
                    _hoisted_12
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", _hoisted_18, _toDisplayString(runningFlowsCount.value
                        ? runningFlowsCount.value + " flows are running."
                        : "No flows currently running"), 1),
                    _hoisted_19
                  ])
                ]),
                false
                  ? (_openBlock(), _createBlock(_unref(ElCarousel), {
                      key: 0,
                      height: "198px",
                      indicator: 1500
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runningFlowLogs.value, (item, index) => {
                          return (_openBlock(), _createBlock(_unref(ElCarouselItem), { key: index }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElCard), { class: "oneTeg-card oneTeg-card-body oneTeg-card-body--no-padding" }, {
                                default: _withCtx(() => [
                                  _hoisted_20,
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("h5", _hoisted_22, _toDisplayString(item.flowName), 1),
                                    _createElementVNode("p", _hoisted_23, _toDisplayString(item.elapsedTime), 1),
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(item.status), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_25
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (setChart.value)
                        ? (_openBlock(), _createBlock(_unref(LineChart), {
                            key: 0,
                            class: "height-100",
                            chartData: chartData.value,
                            options: chartOptions.value
                          }, null, 8, ["chartData", "options"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ElRadio), {
                        modelValue: startDate.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                        label: 'now-1d'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Last Day")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_unref(ElRadio), {
                        modelValue: startDate.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
                        label: 'now-1w'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Last Week")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_unref(ElRadio), {
                        modelValue: startDate.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDate).value = $event)),
                        label: 'now-1M'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Last Month")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_unref(ElRadio), {
                        modelValue: startDate.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((startDate).value = $event)),
                        label: 'now-1y'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Last Year")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_unref(ElRadio), {
                        modelValue: interval.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((interval).value = $event)),
                        label: 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Daily")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_unref(ElRadio), {
                        modelValue: interval.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((interval).value = $event)),
                        label: 1
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Weekly")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_unref(ElRadio), {
                        modelValue: interval.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((interval).value = $event)),
                        label: 2
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Monthly")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_unref(ElRadio), {
                        modelValue: interval.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((interval).value = $event)),
                        label: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Yearly")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              (scheduledFlowItems.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(ElTimeline), {
                    key: 0,
                    class: "padding-5"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduledFlowItems.value, (item, index) => {
                        return (_openBlock(), _createBlock(_unref(ElTimelineItem), {
                          icon: item.icon,
                          size: item.size,
                          type: item.type,
                          timestamp: item.time,
                          key: index
                        }, {
                          default: _withCtx(() => [
                            (item.id && _unref(hasPermission)('FLOWS.LIST.EDIT'))
                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                  key: 0,
                                  class: "timeline-link",
                                  to: {
                    path: `/activities/${item.id}`,
                    query: { flowId: item.flowId, version: item.version },
                  },
                                  "aria-label": `Open activity ${item.name}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "aria-label"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(item.name), 1))
                          ]),
                          _: 2
                        }, 1032, ["icon", "size", "type", "timestamp"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(t)("Common.NoScheduledFlows")), 1))
            ]),
            (loadingScheduledActivities.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("img", {
                    src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                    alt: "Loading...",
                    class: "loader-logo-25"
                  }, null, 8, _hoisted_39)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_unref(ElTimeline), { class: "padding-5" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineItems.value, (item, index) => {
                    return (_openBlock(), _createBlock(_unref(ElTimelineItem), {
                      icon: item.icon,
                      size: item.size,
                      type: item.type,
                      timestamp: item.time,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        (
                    item.id &&
                    _unref(hasPermission)('FLOWS.LIST.EDIT') &&
                    !_unref(isSkipped)(item.status)
                  )
                          ? (_openBlock(), _createBlock(_component_RouterLink, {
                              key: 0,
                              class: "timeline-link",
                              to: {
                    path: `/activities/${item.id}`,
                    query: { flowId: item.flowId, version: item.version },
                  },
                              "aria-label": `Open activity ${item.name}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "aria-label"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(item.name), 1))
                      ]),
                      _: 2
                    }, 1032, ["icon", "size", "type", "timestamp"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            (loadingRecentActivities.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("img", {
                    src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                    alt: "Loading...",
                    class: "loader-logo-25"
                  }, null, 8, _hoisted_45)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(ProcessLogDialog, {
      dialog: processLogDialogVisible.value,
      logBuffer: logBuffer.value,
      moved: false,
      onClose: closeProcessLogDialog
    }, null, 8, ["dialog", "logBuffer"])
  ], 64))
}
}

})